import type { Team } from '../types';

let teamIdCounter = 0;

export function resetTeamIdCounter(): void {
  teamIdCounter = 0;
}

/** Set counter to max existing ID so new teams get unique IDs (call after load). */
export function syncTeamIdCounter(teams: { id: string }[]): void {
  let max = 0;
  for (const t of teams) {
    const n = parseInt(t.id.replace('team_', ''), 10);
    if (n > max) max = n;
  }
  teamIdCounter = max;
}

export function createTeam(name: string, maxSize: number = 6): Team {
  return {
    id: `team_${++teamIdCounter}`,
    name,
    memberIds: [],
    leaderId: null,
    assignedProjectId: null,
    maxSize,
  };
}
